import { ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter as Router } from "react-router-dom";
import { ApiProvider } from "./contexts/apiContext";
import { AuthProvider } from "./contexts/authContext";
import { CalendarProvider } from "./contexts/calendarContext";
import { ExternalServicesProvider } from "./contexts/externalServicesContext";
import { ProgressProvider } from "./contexts/progressContext";
import { UserProvider } from "./contexts/userContext";
import Main from "./Main";
import theme from "./themes/dark";

type AppProps = {};

const App = (_props: AppProps) => {
  return (
    <div className="App">
      <Router>
        <AuthProvider>
          <ProgressProvider>
            <ApiProvider>
              <ExternalServicesProvider>
                <CalendarProvider>
                  <UserProvider>
                    <ChakraProvider theme={theme}>
                      <Main />
                    </ChakraProvider>
                  </UserProvider>
                </CalendarProvider>
              </ExternalServicesProvider>
            </ApiProvider>
          </ProgressProvider>
        </AuthProvider>
      </Router>
    </div>
  );
};

export default App;
